<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onRefresh()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <div class="row">
        <!-- General -->
        <section class="tw-w-full">
          <fieldset class="tw-h-full">
            <legend class="tw-flex-center">
              <i class="mdi mdi-poll tw-ml-2 mdi-24px"></i>
              {{ pageVocabs + "legends.generalInformation" | translate }}
            </legend>

            <div class="row">
              <!-- title -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                <form-field
                  class="tw-w-full"
                  [(value)]="model.title"
                  [control]="form?.get('title')"
                  label="common.title"
                >
                </form-field>
              </div>

              <!-- privateNumberId -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                <private-number-select-search
                  [label]="fields + 'privateNumberId' | translate"
                  [control]="form?.get('privateNumberId')"
                  [value]="model.privateNumberId"
                  [sendType]="SendTypes.Single"
                  (itemChange)="onSelectPrivateNumber($event)"
                >
                </private-number-select-search>
              </div>

              <!-- isSendActive -->
              <div
                class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-py-2 tw-flex tw-justify-start tw-items-center"
              >
                <mat-slide-toggle
                  formControlName="isActive"
                  [(ngModel)]="model.isActive"
                >
                  {{ "common.isActive" | translate }}
                </mat-slide-toggle>
              </div>

              <!-- isChildrenChange -->
              <div
                *ngIf="isSuperAdmin"
                class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-py-2 tw-flex tw-justify-start tw-items-center"
              >
                <mat-slide-toggle
                  formControlName="isChildrenChange"
                  [(ngModel)]="model.isChildrenChange"
                >
                  {{ fields + "isChildrenChange" | translate }}
                </mat-slide-toggle>
              </div>

              <!-- start date time picker -->
              <app-periodic-date-time-picker
                [config]="periodicDateTimeConfig"
                (startDateTime)="model.startDateTime = $event"
                (endDateTime)="model.endDateTime = $event"
              >
              </app-periodic-date-time-picker>
            </div>
          </fieldset>
          
        </section>

        <!-- Sender -->
        <section class="tw-w-full md:tw-w-1/2 xl:tw-w-1/3 tw-mt-4">
          <fieldset class="tw-h-full">
            <legend class="tw-flex-center">
              <i class="mdi mdi-sim tw-ml-2 mdi-24px"></i>
              {{ pageVocabs + "legends.senderNumber" | translate }}
            </legend>

            <div class="row">
              <!-- senderConditionType -->
              <div class="sm:tw-w-1/2 md:tw-w-full">
                <enum-select-search
                  enumName="TextParserComparisonOperator"
                  [control]="form?.get('senderConditionType')"
                  [label]="fields + 'senderConditionType'"
                  [(value)]="model.senderConditionType"
                  (onError)="onClose()"
                >
                </enum-select-search>
              </div>

              <!-- senderConditionValue -->
              <div class="tw-w-full">
                <form-field
                  class="tw-w-full"
                  [(value)]="model.senderConditionValue"
                  [control]="form?.get('senderConditionValue')"
                  [label]="fields + 'senderConditionValue'"
                  classList="dir-ltr"
                >
                </form-field>
              </div>

              <!-- senderPhonebookId -->
              <div class="tw-w-full">
                <phonebook-select-search
                  type="phonebooksListForServices"
                  [label]="fields + 'senderPhonebookId' | translate"
                  [control]="form?.get('senderPhonebookId')"
                  [(value)]="model.senderPhonebookId"
                >
                </phonebook-select-search>
              </div>
            </div>
          </fieldset>
        </section>

        <!-- Filter Conditions -->
        <ng-container *ngFor="let formula of model.formulas; let index = index">
          <section class="tw-w-full md:tw-w-1/2 xl:tw-w-1/3 tw-mt-4">
            <fieldset class="filter-conditions tw-h-full tw-relative">
              <legend class="tw-flex-center">
                <i class="mdi mdi-filter tw-ml-2 mdi-24px"></i>
                {{ pageVocabs + "legends.filterConditions" | translate }}
              </legend>

              <!-- if Condition -->
              <app-text-parser-if-condition
                [formPageConfig]="formPageConfig"
                [ifConditionType]="formula.ifConditionType"
                [ifConditionValue]="formula.ifConditionValue"
                (ifConditionType)="formula.ifConditionType = $event"
                (ifConditionValue)="formula.ifConditionValue = $event"
              >
              </app-text-parser-if-condition>

              <!-- then Condition -->
              <app-text-parser-then-condition
                [formPageConfig]="formPageConfig"
                [thenConditionType]="formula.thenConditionType"
                [ifConditionType]="formula.ifConditionType"
                [thenConditionValue]="formula.thenConditionValue"
                (thenConditionType)="formula.thenConditionType = $event"
                (thenConditionValue)="formula.thenConditionValue = $event"
                (form)="thenConditionForms[index] = $event"
              >
              </app-text-parser-then-condition>

              <!-- remove -->
              <i
                *ngIf="this.model.formulas.length != 1"
                class="minus mdi mdi-minus mdi-24px"
                [matTooltip]="'common.delete' | translate"
                (click)="onRemoveFormul(index)"
                [style.left.px]="index != model.formulas?.length - 1 ? 15 : 50"
              >
              </i>
              <!-- add -->
              <i
                *ngIf="index == model.formulas?.length - 1"
                class="plus mdi mdi-plus mdi-24px"
                [matTooltip]="'common.add' | translate"
                (click)="onAddFormul()"
              >
              </i>
            </fieldset>
          </section>
        </ng-container>

        <!-- DuplicateMessageResponse -->
        <ng-container>
          <section class="tw-w-full md:tw-w-1/2 xl:tw-w-1/3 tw-mt-4">
            <fieldset class="tw-h-full">
              <legend class="tw-flex-center">
                <i class="mdi mdi-message-badge-outline tw-ml-2 mdi-24px"></i>
                <span>
                  {{
                    pageVocabs + "legends.duplicateMessageResponse" | translate
                  }}</span
                >
              </legend>
              <div class="row">
                <ng-container>
                  <div>
                    <app-sms-body
                      [form]="form"
                      smsBodyControlName="text"
                      senderNumberControlName="privateNumber"
                      [isAddSignature]="false"
                      [isAddHeader]="false"
                      [isShowSmsTemplate]="false"
                      [isEditMode]="formPageConfig.isEditMode"
                      [senderNumberId]="
                        model.duplicateMessageResponse?.privateNumber?.id
                      "
                      [smsBody]="duplicateMessageResponse"
                      (finalSmsBody)="onSetResponseText($event)"
                      (senderNumber)="onSetResponsePrivateNumber($event)"
                    >
                    </app-sms-body>
                  </div>
                </ng-container>
              </div>
            </fieldset>
          </section>
        </ng-container>
      </div>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
